export enum TextComposerLoadingStatus {
  IDLE = "idle",
  LOADING = "loading",
  READY = "ready",
  NONE = "none",
  ERROR = "error",
}

// Cheap, instant, client-side pre-filter for whether the send-confirm modal
// should even bother asking the AI which assist (if any) to recommend.
// Deliberately loose - a false positive just costs one small classify call,
// a false negative means we silently miss a suggestion, which is the safer
// side to err on for something a creator never asked for.
const BROADCAST_KEYWORDS = [
  "everyone",
  "you all",
  "y'all",
  "you guys",
  "hey guys",
  "hey all",
  "hey folks",
];

export const shouldCheckTextComposerRecommendation = (
  message: string,
  numCredits: number
): boolean => {
  if (!message || !message.trim()) {
    return false;
  }

  const commaCount = (message.match(/,/g) || []).length;
  const hasPluginToken = /\/(First Name|Full Name)\b/i.test(message);
  const lowerMessage = message.toLowerCase();
  const hasBroadcastLanguage = BROADCAST_KEYWORDS.some((keyword) =>
    lowerMessage.includes(keyword)
  );
  // Covers the common emoji blocks without needing the `u` flag (unsupported
  // under this project's es5 TS target - CRA relies on Babel for the actual
  // emit, but tsc still typechecks against the target's regex feature set).
  const hasEmoji =
    /[☀-➿]|[\uD83C][\uDF00-\uDFFF]|[\uD83D][\uDC00-\uDE4F]|[\uD83D][\uDE80-\uDEFF]/.test(
      message
    );

  return (
    commaCount >= 2 ||
    !hasPluginToken ||
    hasBroadcastLanguage ||
    numCredits >= 2 ||
    (message.length > 80 && !hasEmoji)
  );
};
